export default __webpack_public_path__ + "static/hero-video-ddecc5ec490e5a460f854e202b8a98a6.mp4";